import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "OfflineMenu" })
export default class OfflineMenu extends Vue {
    public localizer: any = Localizer;
    public isOfflineVersion: boolean = false;

    @Prop() readonly culture: string;
    @Prop() readonly mode: string;
    @Prop() readonly documentationName: string;
    @Prop() readonly documentationSlug: string;
    @Prop() readonly documentationDateUpdated: string;

    get status() {
        return this.$store.getters["offlineStore/status"];
    }

    get routes() {
        return (<any>window).App.routes;
    }

    public created() {
        const self = this;
        if (!navigator.onLine) {
            this.$store.commit("offlineStore/setStatus", "Offline");
            self.isOfflineVersion = true;
        } else {
            navigator.serviceWorker.getRegistrations().then(registrations => {
                for (let registration of registrations) {
                    if (window.location.href.startsWith(registration.scope)) {
                        self.isOfflineVersion = true;
                    }
                }
            });
        }

        this.setServiceWorkerMessages();

        let offlineDateUpdated = this.getOfflineDateUpdated(this.documentationSlug);

        if (this.documentationDateUpdated && offlineDateUpdated && new Date(this.documentationDateUpdated) > new Date(parseInt(offlineDateUpdated, 10))) {
            this.$store.commit("offlineStore/setStatus", "Update");
        }
    }

    public setOfflineVersion() {
        const self = this;

        if ("serviceWorker" in navigator) {
            navigator.serviceWorker.register("/documentation.serviceworker.js?culture=" + self.culture + "&mode=" + self.mode + "&documentationSlug=" + self.documentationSlug, { scope: "/documentation/" + self.culture.split('-')[0] + "/" + self.documentationSlug });

            self.setOfflineDateUpdated(self.documentationSlug);

            if (navigator.onLine) {
                (<any>window)._paq?.push(["trackEvent", "Download", "Click", self.documentationName]);
            }
        }
    }

    public updateOfflineVersion() {
        const self = this;

        navigator.serviceWorker.getRegistrations().then(function (registrations) {
            for (let registration of registrations) {
                registration.active.postMessage("Update");
            }

            self.setOfflineDateUpdated(self.documentationSlug);
        });
    }

    public setServiceWorkerMessages() {
        const self = this;

        navigator.serviceWorker.addEventListener("message", (event) => {
            if (event.data.msg !== 100) {
                self.$store.commit("offlineStore/setStatus", "DownloadProgress");
                self.$store.commit("offlineStore/setDownloadPercentage", event.data.msg);
            } else {
                self.$store.commit("offlineStore/setStatus", "DownloadComplete");
                self.$store.commit("offlineStore/setDownloadPercentage", 0);

                setTimeout(x => {
                    self.$store.commit("offlineStore/setStatus", "Online");
                }, 3000);

                self.isOfflineVersion = true;
            }
        });
    }

    public setOfflineDateUpdated(documentationSlug: string) {
        localStorage.setItem(documentationSlug + "_dateupdated", new Date(this.documentationDateUpdated).getTime().toString());
    }

    public getOfflineDateUpdated(documentationSlug: string): string {
        return localStorage.getItem(documentationSlug + "_dateupdated");
    }
};